import React, { useEffect } from 'react'
import TableComponent from '../../../Common/TableComponent/tableComponent'
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import { useState } from 'react';
import * as XLSX from "xlsx";
import { useForm } from 'react-hook-form';
import { TableLoader } from '../../../Common/ShimmerLoader';
import { CollectionPointDayClearanceCircleWiseReportResult, CollectionPointDayClearanceZoneWiseReportResult,  } from '../../../Apis/gvpClearanceReportApi';
 
function GVPDayClearence() {
  const { register, handleSubmit, setValue, formState: { errors }, } = useForm();
  const zoneheaders = [
    "zone",
    "existingCollectionPoint",
    "morningCleared",
    "afterNoonCleared",
    "nightCleared",
    "oneTimeCleared",
    "clearedPercentage",
    "multipleTimeCleared",
    "hotspotCleared",
    "totalCleared",
  ];
  const circleheaders = [
    "circle",
    "existingCollectionPoint",
    "morningCleared",
    "afterNoonCleared",
    "nightCleared",
    "oneTimeCleared",
    "clearedPercentage",
    "multipleTimeCleared",
    "hotspotCleared",
    "totalCleared",
  ];
  const [selectedTab, setSelectedTab] = useState(0);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [getZoneReport, setgetZoneReport] = useState([]);
  const [getCircleReport, setgetCircleReport] = useState([]);

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDateToISOString(today);
    setValue('Date', formattedDate);
    if (selectedTab === 0) {
      searchZoneReport({ Date: formattedDate });
    } else {
      searchCircleReport({ Date: formattedDate });
    }
  }, [selectedTab]);

  const formatDateToISOString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const searchZoneReport = async (data) => {
    setIsOptionsLoading(true);
    try {
      const Date = data.Date || "";
      const requestData = {
        Date,
      }
      const res = await CollectionPointDayClearanceZoneWiseReportResult(requestData);
      const zoneDataResponse = res.data.map(zoneData => ({
        ...zoneData,
        zone: zoneData.zoneName,
      }));
      setgetZoneReport(zoneDataResponse)
    } catch (error) {
      //console.log(error)
    } finally {
      setIsOptionsLoading(false);
    }
  }
 
  const searchCircleReport = async (data) => {
    setIsOptionsLoading(true);
    try {
      const Date = data.Date || "";
      const requestData = {
        Date,
      }
      const res = await CollectionPointDayClearanceCircleWiseReportResult(requestData);
      const circleDataResponse = res.data.map(circleData => ({
        ...circleData,
        circle: circleData.circleName,
      }));
      // setgetCircleReport(res.data)
      setgetCircleReport(circleDataResponse)
    } catch (error) {
      console.log(error)
    } finally {
      setIsOptionsLoading(false);
    }
  }
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(searchZoneReport);
      callback(searchCircleReport);
    }
  };
  const downloadZoneAsExcel = () => {
    const ws = XLSX.utils.json_to_sheet(getZoneReport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ZoneWiseClearanceReports");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(data);
    downloadLink.download = "ZoneWiseClearanceReports.xlsx";
    downloadLink.click();
  };
  const downloadCircleAsExcel = () => {
    const ws = XLSX.utils.json_to_sheet(getCircleReport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CircleWiseClearanceReports");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(data);
    downloadLink.download = "CircleWiseClearanceReports.xlsx";
    downloadLink.click();
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="text-end mb-3">
                <button
                  className="button-container"
                >
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                </button>
              </div>
              <div className="card">
                <div className="card-body" >
                  <span style={{ display: "flex-Start" }}><h5>GVPs Day Clearance Report</h5></span>
                  <Tabs
                    selectedIndex={selectedTab}
                    onSelect={(index) => setSelectedTab(index)}
                  >
                    <TabList style={{ display: "flex" }}>
                      <Tab className="custom-tab">Zone Wise GVPs Day Clearance Report</Tab>
                      <Tab className="custom-tab">Circle Wise GVPs Day Clearance Report</Tab>
                    </TabList>
                    <TabPanel>
                      <div className="text-end mt-3">
                        <button
                          className="btn btn-danger"
                          style={{ backgroundColor: "#EC1117" }}
                          onClick={downloadZoneAsExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                      <form onSubmit={handleSubmit(searchZoneReport)}
                        onKeyDown={(e) => {
                          handleKeyDown(e, handleSubmit);
                        }}>
                        <div class="row mt-5" style={{ textAlign: "justify" }}>
                          <div class="col-md-3 mb-2">
                            <label htmlFor="Date">Date:</label>
                            <input
                              type="datetime-local"
                              id="Date"
                              {...register('Date')}
                              style={{ backgroundColor: "#fff" }}
                              className="form-control"
                            />
                          </div>
                          <div class="col-md-3 mt-4">
                            <button type="submit" className='btn btn-danger' style={{ backgroundColor: '#EC1117' }}>Search</button>
                          </div>
                        </div>
                      </form>
                      <div className="card mt-2">
                        <div className="card-body">
                          <div className="top-header">
                            <span>
                              {" "}
                              Zone Wise GVPs Day Clearance Report
                            </span>
                          </div>
                          <TableComponent
                            DataFetchURL={getZoneReport}
                            headers={zoneheaders}
                            filterFunction={(data) =>
                              data.filter(
                                (item) => item.status === 1 || item.status === 0
                              )
                            }
                          // editData={handleEditRoute}
                          // editRouteData={editRouteData}
                          // viewData={(id) => handleViewRoute(id)}
                          />
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="text-end mt-3">
                        <button
                          className="btn btn-danger"
                          style={{ backgroundColor: "#EC1117" }}
                          onClick={downloadCircleAsExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                      <form onSubmit={handleSubmit(searchCircleReport)}
                        onKeyDown={(e) => {
                          handleKeyDown(e, handleSubmit);
                        }}>
                        <div class="row mt-5" style={{ textAlign: "justify" }}>
                          <div class="col-md-3 mb-2">
                            <label htmlFor="Date">Date:</label>
                            <input
                              type="datetime-local"
                              id="Date"
                              {...register('Date')}
                              style={{ backgroundColor: "#fff" }}
                              className="form-control"
                            />
                          </div>
                          <div class="col-md-3 mt-4">
                            <button type="submit" className='btn btn-danger' style={{ backgroundColor: '#EC1117' }}>Search</button>
                          </div>
                        </div>
                      </form>
                      <div className="card mt-2">
                        <div className="card-body">
                          <div className="top-header">
                            <span>
                              {" "}
                              Circle Wise GVPs Day Clearance Report
                            </span>
                          </div>
                          {/* <CustomDataTable
                                                        columns={zoneColumns}
                                                        data={getCircleReport}
                                                        isLoading={isLoading}
                                                    /> */}
                          <TableComponent
                            DataFetchURL={getCircleReport}
                            headers={circleheaders}
                            filterFunction={(data) =>
                              data.filter(
                                (item) => item.status === 1 || item.status === 0
                              )
                            }
                          // editData={handleEditRoute}
                          // editRouteData={editRouteData}
                          // viewData={(id) => handleViewRoute(id)}
                          />
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
 
export default GVPDayClearence